webpackJsonp([221374088121123],{

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(a,n){ true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (n), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=n(require,exports,module):a.CountUp=n()}(this,function(a,n,t){var e=function(a,n,t,e,i,r){function o(a){var n,t,e,i,r,o,s=a<0;if(a=Math.abs(a).toFixed(l.decimals),a+="",n=a.split("."),t=n[0],e=n.length>1?l.options.decimal+n[1]:"",l.options.useGrouping){for(i="",r=0,o=t.length;r<o;++r)0!==r&&r%3===0&&(i=l.options.separator+i),i=t[o-r-1]+i;t=i}return l.options.numerals.length&&(t=t.replace(/[0-9]/g,function(a){return l.options.numerals[+a]}),e=e.replace(/[0-9]/g,function(a){return l.options.numerals[+a]})),(s?"-":"")+l.options.prefix+t+e+l.options.suffix}function s(a,n,t,e){return t*(-Math.pow(2,-10*a/e)+1)*1024/1023+n}function u(a){return"number"==typeof a&&!isNaN(a)}var l=this;if(l.version=function(){return"1.9.3"},l.options={useEasing:!0,useGrouping:!0,separator:",",decimal:".",easingFn:s,formattingFn:o,prefix:"",suffix:"",numerals:[]},r&&"object"==typeof r)for(var m in l.options)r.hasOwnProperty(m)&&null!==r[m]&&(l.options[m]=r[m]);""===l.options.separator?l.options.useGrouping=!1:l.options.separator=""+l.options.separator;for(var d=0,c=["webkit","moz","ms","o"],f=0;f<c.length&&!window.requestAnimationFrame;++f)window.requestAnimationFrame=window[c[f]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[c[f]+"CancelAnimationFrame"]||window[c[f]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(a,n){var t=(new Date).getTime(),e=Math.max(0,16-(t-d)),i=window.setTimeout(function(){a(t+e)},e);return d=t+e,i}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(a){clearTimeout(a)}),l.initialize=function(){return!!l.initialized||(l.error="",l.d="string"==typeof a?document.getElementById(a):a,l.d?(l.startVal=Number(n),l.endVal=Number(t),u(l.startVal)&&u(l.endVal)?(l.decimals=Math.max(0,e||0),l.dec=Math.pow(10,l.decimals),l.duration=1e3*Number(i)||2e3,l.countDown=l.startVal>l.endVal,l.frameVal=l.startVal,l.initialized=!0,!0):(l.error="[CountUp] startVal ("+n+") or endVal ("+t+") is not a number",!1)):(l.error="[CountUp] target is null or undefined",!1))},l.printValue=function(a){var n=l.options.formattingFn(a);"INPUT"===l.d.tagName?this.d.value=n:"text"===l.d.tagName||"tspan"===l.d.tagName?this.d.textContent=n:this.d.innerHTML=n},l.count=function(a){l.startTime||(l.startTime=a),l.timestamp=a;var n=a-l.startTime;l.remaining=l.duration-n,l.options.useEasing?l.countDown?l.frameVal=l.startVal-l.options.easingFn(n,0,l.startVal-l.endVal,l.duration):l.frameVal=l.options.easingFn(n,l.startVal,l.endVal-l.startVal,l.duration):l.countDown?l.frameVal=l.startVal-(l.startVal-l.endVal)*(n/l.duration):l.frameVal=l.startVal+(l.endVal-l.startVal)*(n/l.duration),l.countDown?l.frameVal=l.frameVal<l.endVal?l.endVal:l.frameVal:l.frameVal=l.frameVal>l.endVal?l.endVal:l.frameVal,l.frameVal=Math.round(l.frameVal*l.dec)/l.dec,l.printValue(l.frameVal),n<l.duration?l.rAF=requestAnimationFrame(l.count):l.callback&&l.callback()},l.start=function(a){l.initialize()&&(l.callback=a,l.rAF=requestAnimationFrame(l.count))},l.pauseResume=function(){l.paused?(l.paused=!1,delete l.startTime,l.duration=l.remaining,l.startVal=l.frameVal,requestAnimationFrame(l.count)):(l.paused=!0,cancelAnimationFrame(l.rAF))},l.reset=function(){l.paused=!1,delete l.startTime,l.initialized=!1,l.initialize()&&(cancelAnimationFrame(l.rAF),l.printValue(l.startVal))},l.update=function(a){if(l.initialize()){if(a=Number(a),!u(a))return void(l.error="[CountUp] update() - new endVal is not a number: "+a);l.error="",a!==l.frameVal&&(cancelAnimationFrame(l.rAF),l.paused=!1,delete l.startTime,l.startVal=l.frameVal,l.endVal=a,l.countDown=l.startVal>l.endVal,l.rAF=requestAnimationFrame(l.count))}},l.initialize()&&l.printValue(l.startVal)};return e});

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.startAnimation = exports.formatNumber = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _countup = __webpack_require__(91);
	
	var _countup2 = _interopRequireDefault(_countup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Adapted from the countup.js format number function
	// https://github.com/inorganik/countUp.js/blob/master/countUp.js#L46-L60
	var formatNumber = exports.formatNumber = function formatNumber(start, options) {
	  var neg = start < 0;
	  var num = '' + Math.abs(start).toFixed(options.decimals);
	  var x = num.split('.');
	  var x1 = x[0];
	  var x2 = x.length > 1 ? '' + options.decimal + x[1] : '';
	  var rgx = /(\d+)(\d{3})/;
	
	  if (options.separator) {
	    while (rgx.test(x1)) {
	      x1 = x1.replace(rgx, '$1' + options.separator + '$2');
	    }
	  }
	
	  return '' + (neg ? '-' : '') + (options.prefix || '') + x1 + x2 + (options.suffix || '');
	};
	
	var startAnimation = exports.startAnimation = function startAnimation(component) {
	  if (!(component && component.spanElement)) {
	    throw new Error('You need to pass the CountUp component as an argument!\neg. this.myCountUp.startAnimation(this.myCountUp);');
	  }
	
	  var _component$props = component.props,
	      decimal = _component$props.decimal,
	      decimals = _component$props.decimals,
	      duration = _component$props.duration,
	      easingFn = _component$props.easingFn,
	      end = _component$props.end,
	      formattingFn = _component$props.formattingFn,
	      onComplete = _component$props.onComplete,
	      onStart = _component$props.onStart,
	      prefix = _component$props.prefix,
	      separator = _component$props.separator,
	      start = _component$props.start,
	      suffix = _component$props.suffix,
	      useEasing = _component$props.useEasing;
	
	
	  var countupInstance = new _countup2.default(component.spanElement, start, end, decimals, duration, {
	    decimal: decimal,
	    easingFn: easingFn,
	    formattingFn: formattingFn,
	    separator: separator,
	    prefix: prefix,
	    suffix: suffix,
	    useEasing: useEasing,
	    useGrouping: !!separator
	  });
	
	  if (typeof onStart === 'function') {
	    onStart();
	  }
	
	  countupInstance.start(onComplete);
	};
	
	var CountUp = function (_React$Component) {
	  _inherits(CountUp, _React$Component);
	
	  function CountUp() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CountUp);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CountUp.__proto__ || Object.getPrototypeOf(CountUp)).call.apply(_ref, [this].concat(args))), _this), _this.spanElement = null, _this.refSpan = function (span) {
	      _this.spanElement = span;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CountUp, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      startAnimation(this);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var hasCertainPropsChanged = this.props.duration !== nextProps.duration || this.props.end !== nextProps.end || this.props.start !== nextProps.start;
	
	      return nextProps.redraw || hasCertainPropsChanged;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      startAnimation(this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          start = _props.start,
	          decimal = _props.decimal,
	          decimals = _props.decimals,
	          separator = _props.separator,
	          prefix = _props.prefix,
	          suffix = _props.suffix,
	          style = _props.style,
	          formattingFn = _props.formattingFn;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: className, ref: this.refSpan, style: style },
	        typeof formattingFn === 'function' ? formattingFn(start) : formatNumber(start, {
	          decimal: decimal,
	          decimals: decimals,
	          separator: separator,
	          prefix: prefix,
	          suffix: suffix
	        })
	      );
	    }
	  }]);
	
	  return CountUp;
	}(_react2.default.Component);
	
	CountUp.defaultProps = {
	  className: undefined,
	  decimal: '.',
	  decimals: 0,
	  duration: 3,
	  easingFn: null,
	  end: 100,
	  formattingFn: null,
	  onComplete: undefined,
	  onStart: undefined,
	  prefix: '',
	  separator: '',
	  start: 0,
	  suffix: '',
	  redraw: false,
	  style: undefined,
	  useEasing: true
	};
	exports.default = CountUp;

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  padding: 15px 0 !important;\n  span.timer {\n    font-size: 60px !important;\n  }\n"], ["\n  padding: 15px 0 !important;\n  span.timer {\n    font-size: 60px !important;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  background: #fff;\n  padding: 20px;\n  border-radius: 4px;\n  text-align: center;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  margin: 0 10px;\n"], ["\n  background: #fff;\n  padding: 20px;\n  border-radius: 4px;\n  text-align: center;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  margin: 0 10px;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  margin-top: -20px;\n  padding-bottom: 70px;\n"], ["\n  margin-top: -20px;\n  padding-bottom: 70px;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  width: 100% !important;\n"], ["\n  width: 100% !important;\n"]);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_countup_1 = __webpack_require__(68);
	var styled_components_1 = __webpack_require__(2);
	var googleAnalyticsService = __webpack_require__(8);
	var AchievementsCounterBlockElement = function AchievementsCounterBlockElement(props) {
	    var iconString = props.iconString,
	        counterStart = props.counterStart,
	        counterEnd = props.counterEnd,
	        counterDuration = props.counterDuration,
	        counterText = props.counterText,
	        counterReady = props.counterReady;
	
	    return React.createElement(CounterWrapper, { className: "col-sm-6 col-md-6 col-lg-4" }, React.createElement(ShadowEffectWrapper, null, React.createElement("i", { className: "material-icons brand-color", style: { fontSize: '50px' } }, iconString), React.createElement("span", { className: "timer" }, counterReady ? React.createElement(react_countup_1.default, { start: counterStart, end: counterEnd, duration: counterDuration }) : React.createElement("span", null, counterEnd)), React.createElement("span", { className: "count-description" }, counterText)));
	};
	/** STYLES => AchievementsCounterBlockElement */
	var CounterWrapper = styled_components_1.default.div(_templateObject);
	var ShadowEffectWrapper = styled_components_1.default.div(_templateObject2);
	
	var AchievementsCounterBlock = function (_React$Component) {
	    _inherits(AchievementsCounterBlock, _React$Component);
	
	    function AchievementsCounterBlock(props) {
	        _classCallCheck(this, AchievementsCounterBlock);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            countersReady: false
	        };
	        _this.onComponentView = _this.onComponentView.bind(_this);
	        return _this;
	    }
	
	    AchievementsCounterBlock.prototype.onComponentView = function onComponentView() {
	        // ODLICZNIKI
	        this.setState({ countersReady: true });
	        // GOOGLE EVENT
	        if (this.props.componentViewEventType) {
	            googleAnalyticsService.trackEvent(this.props.componentViewEventType);
	        }
	    };
	
	    AchievementsCounterBlock.prototype.render = function render() {
	        var counters = this.props.counters;
	        var countersReady = this.state.countersReady;
	
	        return React.createElement("div", { className: "materialize-theme-styles", onMouseEnter: this.onComponentView }, React.createElement(AchievementsCounterBlockWrapper, { className: "facts-two" }, React.createElement(AchievementsCounterContainerWrapper, { className: "container" }, React.createElement("div", { className: "row text-center" }, counters.map(function (counter, index) {
	            return React.createElement(AchievementsCounterBlockElement, _extends({ key: index }, counter, { counterReady: countersReady }));
	        })))));
	    };
	
	    return AchievementsCounterBlock;
	}(React.Component);
	/** STYLES => AchievementsCounterBlock */
	
	
	var AchievementsCounterBlockWrapper = styled_components_1.default.section(_templateObject3);
	var AchievementsCounterContainerWrapper = styled_components_1.default.div(_templateObject4);
	exports.default = AchievementsCounterBlock;

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  color: rgb(128, 128, 128) !important;\n  margin-top: -25px !important;\n  margin-bottom: 20px !important;\n  font-weight: 300 !important;\n"], ["\n  color: rgb(128, 128, 128) !important;\n  margin-top: -25px !important;\n  margin-bottom: 20px !important;\n  font-weight: 300 !important;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  line-height: 26px !important;\n  span.odometer-suffix {\n    font-size: 16px;\n    margin-left: 4px;\n  }\n"], ["\n  line-height: 26px !important;\n  span.odometer-suffix {\n    font-size: 16px;\n    margin-left: 4px;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  line-height: 15px !important;\n"], ["\n  line-height: 15px !important;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_countup_1 = __webpack_require__(68);
	var googleAnalyticsService = __webpack_require__(8);
	var styled_components_1 = __webpack_require__(2);
	
	var FullWidthImageOnLeftBlock = function (_React$Component) {
	    _inherits(FullWidthImageOnLeftBlock, _React$Component);
	
	    function FullWidthImageOnLeftBlock(props) {
	        _classCallCheck(this, FullWidthImageOnLeftBlock);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            odometersReady: false
	        };
	        _this.onComponentView = _this.onComponentView.bind(_this);
	        return _this;
	    }
	
	    FullWidthImageOnLeftBlock.prototype.onComponentView = function onComponentView() {
	        // ODLICZNIKI
	        this.setState({ odometersReady: true });
	        // GOOGLE EVENT
	        if (this.props.componentViewEventType) {
	            googleAnalyticsService.trackEvent(this.props.componentViewEventType);
	        }
	    };
	
	    FullWidthImageOnLeftBlock.prototype.render = function render() {
	        var _props = this.props,
	            blockTitlePart1Black = _props.blockTitlePart1Black,
	            blockTitlePart2Blue = _props.blockTitlePart2Blue,
	            blockTitlePart3Black = _props.blockTitlePart3Black,
	            blockSubtitle = _props.blockSubtitle,
	            numberBoxParagraphs = _props.numberBoxParagraphs,
	            odometers = _props.odometers;
	        var odometersReady = this.state.odometersReady;
	        // SPRAWDZANIE CZY SUBTITLE JEST LISTĄ
	
	        var blockSubtitleIsArray = Array.isArray(blockSubtitle);
	        // ZWRACANIE DANYCH
	        return React.createElement("div", { className: "goodgrowth-theme-styles", onMouseEnter: this.onComponentView }, React.createElement("section", { className: "numbers" }, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-sm-3 col-md-4 col-lg-6" }), React.createElement("div", { className: "col-sm-9 col-md-8 col-lg-6" }, React.createElement("h2", null, blockTitlePart1Black, React.createElement("span", null, blockTitlePart2Blue), blockTitlePart3Black), !blockSubtitleIsArray && React.createElement(StyledH4, null, blockSubtitle), blockSubtitleIsArray && blockSubtitle.map(function (blockSubtitlePart, i) {
	            return React.createElement(StyledH4, { key: i }, blockSubtitlePart);
	        }), React.createElement("div", { className: "row no-gutter wow fadeInUp", "data-wow-duration": "600ms", "data-wow-delay": "600ms" }, React.createElement("div", { className: "col-sm-8 col-md-8 col-lg-9" }, React.createElement("div", { className: "numbersbox" }, numberBoxParagraphs.map(function (paragraph, index) {
	            return React.createElement("p", { key: index }, paragraph);
	        }))), React.createElement("div", { className: "col-sm-4 col-md-4 col-lg-3" }, React.createElement("div", { className: "numbersbox-small" }, odometers.map(function (odometer, index) {
	            return React.createElement(StyledOdometerNumber, { className: "number", key: index }, React.createElement("div", { className: "odometer" }, odometersReady ? React.createElement(react_countup_1.default, { start: odometer.odometerStart, end: odometer.odometerEnd, duration: odometer.odometerDuration }) : React.createElement("span", null, odometer.odometerEnd), React.createElement("span", { className: "odometer-suffix" }, odometer.odometerSuffix)), React.createElement(StyledAchievementsName, { className: "numbername" }, odometer.odometerTitle));
	        }))))))));
	    };
	
	    return FullWidthImageOnLeftBlock;
	}(React.Component);
	/** styles */
	
	
	var StyledH4 = styled_components_1.default.h4(_templateObject);
	var StyledOdometerNumber = styled_components_1.default.div(_templateObject2);
	var StyledAchievementsName = styled_components_1.default.div(_templateObject3);
	exports.default = FullWidthImageOnLeftBlock;

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  a {\n    margin-bottom: 0 !important;\n    line-height: 22px !important;\n  }\n"], ["\n  a {\n    margin-bottom: 0 !important;\n    line-height: 22px !important;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  color: rgb(128, 128, 128) !important;\n  font-size: 20px !important;\n  margin-top: -25px !important;\n  margin-bottom: 20px !important;\n  font-weight: 300 !important;\n"], ["\n  color: rgb(128, 128, 128) !important;\n  font-size: 20px !important;\n  margin-top: -25px !important;\n  margin-bottom: 20px !important;\n  font-weight: 300 !important;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var googleAnalyticsService = __webpack_require__(8);
	
	var FullWidthImageOnRightBlock = function (_React$Component) {
	    _inherits(FullWidthImageOnRightBlock, _React$Component);
	
	    function FullWidthImageOnRightBlock(props) {
	        _classCallCheck(this, FullWidthImageOnRightBlock);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.onComponentView = _this.onComponentView.bind(_this);
	        _this.onButtonClick = _this.onButtonClick.bind(_this);
	        return _this;
	    }
	
	    FullWidthImageOnRightBlock.prototype.onComponentView = function onComponentView() {
	        if (this.props.componentViewEventType) {
	            googleAnalyticsService.trackEvent(this.props.componentViewEventType);
	        }
	    };
	
	    FullWidthImageOnRightBlock.prototype.onButtonClick = function onButtonClick() {
	        if (this.props.buttonClickEventType) {
	            googleAnalyticsService.trackEvent(this.props.buttonClickEventType);
	        }
	    };
	
	    FullWidthImageOnRightBlock.prototype.render = function render() {
	        var _props = this.props,
	            blockTitlePart1Black = _props.blockTitlePart1Black,
	            blockTitlePart2Blue = _props.blockTitlePart2Blue,
	            blockTitlePart3Black = _props.blockTitlePart3Black,
	            blockSubtitle = _props.blockSubtitle,
	            blockParagraphs = _props.blockParagraphs,
	            blockButtonText = _props.blockButtonText,
	            blockButtonLink = _props.blockButtonLink;
	        // SPRAWDZANIE CZY SUBTITLE JEST LISTĄ
	
	        var blockSubtitleIsArray = Array.isArray(blockSubtitle);
	        // ZWRACANIE DANYCH
	        return React.createElement("div", { className: "goodgrowth-theme-styles", onMouseEnter: this.onComponentView }, React.createElement(FullWidthImageOnRightBlockWrapper, { className: "aboutus" }, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-sm-8 col-md-6 wow fadeInLeft" }, React.createElement("hr", { className: "small" }), React.createElement("h2", null, blockTitlePart1Black, React.createElement("span", null, blockTitlePart2Blue), blockTitlePart3Black), !blockSubtitleIsArray && React.createElement(StyledH4, null, blockSubtitle), blockSubtitleIsArray && blockSubtitle.map(function (blockSubtitlePart, i) {
	            return React.createElement(StyledH4, { key: i }, blockSubtitlePart);
	        }), blockParagraphs.map(function (paragraph, index) {
	            return React.createElement("p", { key: index }, paragraph);
	        }), React.createElement("a", { className: "btn btn-default", href: blockButtonLink, target: "_blank", onClick: this.onButtonClick }, blockButtonText)), React.createElement("div", { className: "col-sm-4 col-md-6" }))));
	    };
	
	    return FullWidthImageOnRightBlock;
	}(React.Component);
	/** STYLES */
	
	
	var FullWidthImageOnRightBlockWrapper = styled_components_1.default.section(_templateObject);
	var StyledH4 = styled_components_1.default.h4(_templateObject2);
	exports.default = FullWidthImageOnRightBlock;

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background-image: url(", ");\n  background-size: cover !important;\n  background-attachment: inherit !important;\n  height: 600px !important;\n  div.container {\n    width: 90%;\n  }\n  /* TELEFON => STA\u0141Y NAG\u0141\xD3WEK MA OK. 117PX, A TRE\u015A\u0106 HERO JEST WY\u017BSZA NI\u017B 600PX => H1 CHOWA\u0141 SI\u0118 POD MENU */\n  @media (max-width: 600px) {\n    height: auto !important;\n    padding-top: 130px;\n    padding-bottom: 40px;\n  }\n  /* BARDZO W\u0104SKI EKRAN => MENU ZAWIJA SI\u0118, NAG\u0141\xD3WEK MA OK. 153PX */\n  @media (max-width: 360px) {\n    padding-top: 165px;\n  }\n  @media (max-width: 1200px) {\n    h1.intro-title {\n      font-size: 32px !important;\n    }\n  }\n  h1.intro-h1 {\n    font-size: 40px !important;\n    line-height: 44px !important;\n    margin: 0 0 20px 0;\n    span {\n      display: block;\n    }\n  }\n"], ["\n  background-image: url(", ");\n  background-size: cover !important;\n  background-attachment: inherit !important;\n  height: 600px !important;\n  div.container {\n    width: 90%;\n  }\n  /* TELEFON => STA\u0141Y NAG\u0141\xD3WEK MA OK. 117PX, A TRE\u015A\u0106 HERO JEST WY\u017BSZA NI\u017B 600PX => H1 CHOWA\u0141 SI\u0118 POD MENU */\n  @media (max-width: 600px) {\n    height: auto !important;\n    padding-top: 130px;\n    padding-bottom: 40px;\n  }\n  /* BARDZO W\u0104SKI EKRAN => MENU ZAWIJA SI\u0118, NAG\u0141\xD3WEK MA OK. 153PX */\n  @media (max-width: 360px) {\n    padding-top: 165px;\n  }\n  @media (max-width: 1200px) {\n    h1.intro-title {\n      font-size: 32px !important;\n    }\n  }\n  h1.intro-h1 {\n    font-size: 40px !important;\n    line-height: 44px !important;\n    margin: 0 0 20px 0;\n    span {\n      display: block;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  color: black;\n"], ["\n  color: black;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var googleAnalyticsService = __webpack_require__(8);
	var styled_components_1 = __webpack_require__(2);
	
	var HeroTextOnRightBlock = function (_React$Component) {
	    _inherits(HeroTextOnRightBlock, _React$Component);
	
	    function HeroTextOnRightBlock(props) {
	        _classCallCheck(this, HeroTextOnRightBlock);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.onComponentView = _this.onComponentView.bind(_this);
	        _this.onButtonClick = _this.onButtonClick.bind(_this);
	        return _this;
	    }
	
	    HeroTextOnRightBlock.prototype.onComponentView = function onComponentView() {
	        if (this.props.componentViewEventType) {
	            googleAnalyticsService.trackEvent(this.props.componentViewEventType);
	        }
	    };
	
	    HeroTextOnRightBlock.prototype.onButtonClick = function onButtonClick() {
	        if (this.props.buttonClickEventType) {
	            googleAnalyticsService.trackEvent(this.props.buttonClickEventType);
	        }
	    };
	
	    HeroTextOnRightBlock.prototype.render = function render() {
	        // DANE UNIWERSALNE
	        var _props = this.props,
	            titleLine1 = _props.titleLine1,
	            titleLine2 = _props.titleLine2,
	            description = _props.description,
	            buttonText = _props.buttonText,
	            buttonLink = _props.buttonLink,
	            backgroundImage = _props.backgroundImage;
	        // ZWRACANIE DANYCH
	
	        return React.createElement("div", { className: "materialize-theme-styles", onMouseEnter: this.onComponentView }, React.createElement(HeroBlockWrapper, { className: "parallax-bg valign-wrapper", backgroundImage: backgroundImage }, React.createElement("div", { className: "valign-cell" }, React.createElement("div", { className: "container" }, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-md-6 col-md-offset-6 col-sm-offset-4 col-sm-8 col-xs-12" }, React.createElement("h1", { className: "intro-title intro-h1" }, titleLine1, titleLine2 && " ", titleLine2 && React.createElement("span", null), titleLine2 && titleLine2), description.map(function (description, index) {
	            return React.createElement(HeroBlockTitleDescriptionWrapper, { key: index, className: "lead" }, description);
	        }), React.createElement("a", { href: buttonLink, target: this.props.buttonLinkIsForScrolling ? "" : "_blank", className: "btn btn-lg waves-effect waves-light mt-20", onClick: this.onButtonClick }, buttonText)))))));
	    };
	
	    return HeroTextOnRightBlock;
	}(React.Component);
	/** STYLES */
	
	
	var HeroBlockWrapper = styled_components_1.default.section(_templateObject, function (props) {
	    return props.backgroundImage;
	});
	var HeroBlockTitleDescriptionWrapper = styled_components_1.default.p(_templateObject2);
	exports.default = HeroTextOnRightBlock;

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto' !important;\n  div.shadow-effect {\n    box-shadow: 0 19px 38px rgba(0, 0, 0, 0.1), 0 15px 12px rgba(0, 0, 0, 0.02), 0 -3px 10px -3px rgba(0,0,0,0.1);\n  }\n  p {\n    font-size: 15px !important;\n    font-weight: 400 !important;\n  }\n"], ["\n  font-family: 'Roboto' !important;\n  div.shadow-effect {\n    box-shadow: 0 19px 38px rgba(0, 0, 0, 0.1), 0 15px 12px rgba(0, 0, 0, 0.02), 0 -3px 10px -3px rgba(0,0,0,0.1);\n  }\n  p {\n    font-size: 15px !important;\n    font-weight: 400 !important;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  margin-top: -50px;\n  padding-top: 10px !important;\n"], ["\n  margin-top: -50px;\n  padding-top: 10px !important;\n"]);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var googleAnalyticsService = __webpack_require__(8);
	var IntroStepBlockElement = function IntroStepBlockElement(props) {
	    var elementNumber = props.elementNumber,
	        elementNumberColor = props.elementNumberColor,
	        elementTitle = props.elementTitle,
	        elementText = props.elementText;
	
	    return React.createElement(IntroStepBlockElementWrapper, { className: "col-sm-4 wow fadeInUp" }, React.createElement("div", { className: "shadow-effect" }, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-sm-12 col-md-3" }, React.createElement("div", { className: "number " + elementNumberColor }, elementNumber)), React.createElement("div", { className: "col-sm-12 col-md-9" }, React.createElement("h4", null, elementTitle), React.createElement("p", null, elementText)))));
	};
	/** STYLES => IntroStepBlockElement */
	var IntroStepBlockElementWrapper = styled_components_1.default.div(_templateObject);
	
	var IntroStepBlock = function (_React$Component) {
	    _inherits(IntroStepBlock, _React$Component);
	
	    function IntroStepBlock(props) {
	        _classCallCheck(this, IntroStepBlock);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.onComponentView = _this.onComponentView.bind(_this);
	        return _this;
	    }
	
	    IntroStepBlock.prototype.onComponentView = function onComponentView() {
	        if (this.props.componentViewEventType) {
	            googleAnalyticsService.trackEvent(this.props.componentViewEventType);
	        }
	    };
	
	    IntroStepBlock.prototype.render = function render() {
	        var steps = this.props.steps;
	
	        return React.createElement("div", { className: "goodgrowth-theme-styles", onMouseEnter: this.onComponentView }, React.createElement(IntroStepBlockWrapper, { className: "introtext about1" }, React.createElement("div", { className: "about1-numbers" }, React.createElement("div", { className: "row" }, steps.map(function (step, index) {
	            return React.createElement(IntroStepBlockElement, _extends({ key: index }, step));
	        })))));
	    };
	
	    return IntroStepBlock;
	}(React.Component);
	/** STYLES => IntroStepBlock */
	
	
	var IntroStepBlockWrapper = styled_components_1.default.section(_templateObject2);
	exports.default = IntroStepBlock;

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  padding-top: 110px;\n  padding-bottom: 40px;\n"], ["\n  padding-top: 110px;\n  padding-bottom: 40px;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var package_comparison_header_1 = __webpack_require__(146);
	var package_comparison_expandable_element_1 = __webpack_require__(145);
	var styled_components_1 = __webpack_require__(2);
	
	var PackageComparisonBlock = function (_React$Component) {
	    _inherits(PackageComparisonBlock, _React$Component);
	
	    function PackageComparisonBlock() {
	        _classCallCheck(this, PackageComparisonBlock);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    PackageComparisonBlock.prototype.render = function render() {
	        return React.createElement("div", { className: "materialize-theme-styles" }, React.createElement(PackageComparisonBlockWrapper, null, React.createElement("div", { className: "container" }, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-12" }, React.createElement("div", { className: "panel-group feature-accordion brand-accordion icon angle-icon", id: "basic" }, React.createElement(package_comparison_header_1.default, null), React.createElement(package_comparison_expandable_element_1.default, { appModuleName: "Moduł Fakturowy", appModuleElements: [{
	                elementName: "Faktury sprzedaży z VAT i bez VAT",
	                elementIsFree: true
	            }, {
	                elementName: "Faktury pro forma",
	                elementIsFree: true
	            }, {
	                elementName: "Faktury na podstawie pro formy",
	                elementIsFree: true
	            }, {
	                elementName: "Faktury korygujące",
	                elementIsFree: true
	            }, {
	                elementName: "Własne logo na fakturze",
	                elementIsFree: true
	            }, {
	                elementName: "Wiele schematów numeracji faktur",
	                elementIsFree: true
	            }, {
	                elementName: "Własna numeracja faktur",
	                elementIsFree: true
	            }, {
	                elementName: "Wysyłanie faktur e-mailem",
	                elementIsFree: true
	            }, {
	                elementName: "Eksportowanie faktur w różnych formatach",
	                elementIsFree: true
	            }, {
	                elementName: "Faktury w języku angielskim",
	                elementIsFree: true
	            }, {
	                elementName: "Faktury w różnych walutach",
	                elementIsFree: true
	            }, {
	                elementName: "Kilka szablonów faktur",
	                elementIsFree: true
	            }, {
	                elementName: "Zapisywanie produktów",
	                elementIsFree: true
	            }, {
	                elementName: "Zbiorcze pobieranie faktur",
	                elementIsFree: true
	            }, {
	                elementName: "Integracja z GUS",
	                elementIsFree: true
	            }, {
	                elementName: "Integracja z KSeF",
	                elementIsFree: true
	            }, {
	                elementName: "Wiele rachunków bankowych",
	                elementIsFree: true
	            }] }), React.createElement(package_comparison_expandable_element_1.default, { appModuleName: "Moduł CRM", appModuleElements: [{
	                elementName: "Katalog kontrahentów",
	                elementIsFree: true
	            }, {
	                elementName: "Import kontrahentów z GUS",
	                elementIsFree: true
	            }, {
	                elementName: "Zaawansowane ustawienia kontrahentów",
	                elementIsFree: true
	            }] }), React.createElement(package_comparison_expandable_element_1.default, { appModuleName: "Moduł Księgowość", appModuleElements: [{
	                elementName: "Polityka rachunkowości",
	                elementIsFree: false
	            }, {
	                elementName: "Plan kont",
	                elementIsFree: false
	            }, {
	                elementName: "Dziennik",
	                elementIsFree: false
	            }, {
	                elementName: "Księga główna",
	                elementIsFree: false
	            }, {
	                elementName: "Księga pomocnicza",
	                elementIsFree: false
	            }, {
	                elementName: "Zestaw. obr. i sald księgi głównej",
	                elementIsFree: false
	            }, {
	                elementName: "Zestaw. obr. i sald księgi pomocniczej",
	                elementIsFree: false
	            }, {
	                elementName: "Schematy księgowania przychodów",
	                elementIsFree: false
	            }, {
	                elementName: "Schematy księgowania kosztów",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracje VAT",
	                elementIsFree: false
	            }, {
	                elementName: "Rejestry VAT sprzedaży",
	                elementIsFree: false
	            }, {
	                elementName: "Rejestry VAT zakupu",
	                elementIsFree: false
	            }, {
	                elementName: "JPK_V7",
	                elementIsFree: false
	            }, {
	                elementName: "JPK_KR",
	                elementIsFree: false
	            }, {
	                elementName: "JPK_FA",
	                elementIsFree: false
	            }, {
	                elementName: "Potwierdzenia sald kontrahentów",
	                elementIsFree: false
	            }, {
	                elementName: "Automatyczne rozliczenie WNT",
	                elementIsFree: false
	            }, {
	                elementName: "Automatyczne rozliczenie Importu Usług",
	                elementIsFree: false
	            }, {
	                elementName: "Metoda kasowa VAT",
	                elementIsFree: false
	            }, {
	                elementName: "Księgowość podmiotów zwolnionych z VAT",
	                elementIsFree: false
	            }, {
	                elementName: "Zaliczki CIT",
	                elementIsFree: false
	            }, {
	                elementName: "Rejestry CIT",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracje CIT",
	                elementIsFree: false
	            }, {
	                elementName: "Środki Trwałe",
	                elementIsFree: false
	            }, {
	                elementName: "Sprawozdania finansowe",
	                elementIsFree: false
	            }, {
	                elementName: "Uchwały do sprawozdania finansowego",
	                elementIsFree: false
	            }, {
	                elementName: "Kalendarz z przypomnieniami",
	                elementIsFree: false
	            }, {
	                elementName: "Wysyłanie JPK i eDeklaracji",
	                elementIsFree: false
	            }, {
	                elementName: "Rozrachunki z kontrahentami",
	                elementIsFree: false
	            }] }), React.createElement(package_comparison_expandable_element_1.default, { appModuleName: "Moduł Kadrowy", appModuleElements: [{
	                elementName: "Rejestr osobowy",
	                elementIsFree: false
	            }, {
	                elementName: "Rozliczanie umów o pracę",
	                elementIsFree: false
	            }, {
	                elementName: "Rozliczanie umów zlecenia",
	                elementIsFree: false
	            }, {
	                elementName: "Rozliczanie umów o dzieło",
	                elementIsFree: false
	            }, {
	                elementName: "Rozliczanie licencji",
	                elementIsFree: false
	            }, {
	                elementName: "Rozliczanie aktów powołania",
	                elementIsFree: false
	            }, {
	                elementName: "Rozliczanie świadczeń niepieniężnych",
	                elementIsFree: false
	            }, {
	                elementName: "Rozliczanie praktyk absolwenckich",
	                elementIsFree: false
	            }, {
	                elementName: "Rozliczania ryczałtowe",
	                elementIsFree: false
	            }, {
	                elementName: "Listy płac",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracja PIT-11",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracja PIT-4R",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracja ZUS DRA",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracja ZUS RCA",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracja ZUS RZA",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracja ZUS ZUA",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracja ZUS ZPA",
	                elementIsFree: false
	            }] }), React.createElement(package_comparison_expandable_element_1.default, { appModuleName: "Analizy finansowe", appModuleElements: [{
	                elementName: "Wykresy przychodów i kosztów",
	                elementIsFree: false
	            }, {
	                elementName: "Prognozy podatkowe",
	                elementIsFree: false
	            }] }), React.createElement(package_comparison_expandable_element_1.default, { appModuleName: "Bezpieczeństwo danych", appModuleElements: [{
	                elementName: "Aktualizacje aplikacji",
	                elementIsFree: true
	            }, {
	                elementName: "Kopie zapasowe baz danych",
	                elementIsFree: true
	            }, {
	                elementName: "Zabezpieczona transmisja danych",
	                elementIsFree: true
	            }] }), React.createElement(package_comparison_expandable_element_1.default, { appModuleName: "Pozostałe funkcje", appModuleElements: [{
	                elementName: "Wsparcie księgowe",
	                elementIsFree: false
	            }, {
	                elementName: "Wsparcie techniczne",
	                elementIsFree: true
	            }, {
	                elementName: "Konta użytkowników",
	                elementIsFree: true
	            }, {
	                elementName: "Nadawanie przywilejów nowym użytkownikom",
	                elementIsFree: true
	            }, {
	                elementName: "Wiele firm jednego użytkownika",
	                elementIsFree: true
	            }] })))))));
	    };
	
	    return PackageComparisonBlock;
	}(React.Component);
	/** STYLES */
	
	
	var PackageComparisonBlockWrapper = styled_components_1.default.section(_templateObject);
	exports.default = PackageComparisonBlock;

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  height: 55px;\n  padding-right: 2px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  height: 55px;\n  padding-right: 2px;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  flex-basis: 40%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  color: #4d4d4d;\n"], ["\n  flex-basis: 40%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  color: #4d4d4d;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  flex-basis: 30%;\n  max-width: 300px;\n  box-shadow: 0 9px 0px 0px #fff, 0 -9px 0px 0px #fff, 12px 0 22px -4px rgba(0, 0, 0, 0.12), -12px 0 22px -4px rgba(0, 0, 0, 0.12);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  i.fa.fa-check {\n    color: green;\n  }\n  i.fa.fa-times {\n    color: red;\n  }\n"], ["\n  flex-basis: 30%;\n  max-width: 300px;\n  box-shadow: 0 9px 0px 0px #fff, 0 -9px 0px 0px #fff, 12px 0 22px -4px rgba(0, 0, 0, 0.12), -12px 0 22px -4px rgba(0, 0, 0, 0.12);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  i.fa.fa-check {\n    color: green;\n  }\n  i.fa.fa-times {\n    color: red;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  padding-right: 2px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  padding-right: 2px;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  flex-basis: 40%;\n"], ["\n  flex-basis: 40%;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  flex-basis: 30%;\n  max-width: 300px;\n  // box-shadow: 0 4px 2px 2px rgba(0, 0, 0, 0.12);\n  height: 1px;\n  border-bottom: 3px solid rgba(0, 0, 0, 0.12);\n"], ["\n  flex-basis: 30%;\n  max-width: 300px;\n  // box-shadow: 0 4px 2px 2px rgba(0, 0, 0, 0.12);\n  height: 1px;\n  border-bottom: 3px solid rgba(0, 0, 0, 0.12);\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  h3 {\n    line-height: 1.1rem;  \n  }\n"], ["\n  h3 {\n    line-height: 1.1rem;  \n  }\n"]);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var PackageComparisonExpandableElementRow = function PackageComparisonExpandableElementRow(props) {
	  var elementName = props.elementName,
	      elementIsFree = props.elementIsFree;
	
	  return React.createElement(PackageComparisonExpandableElementRowWrapper, null, React.createElement(FeatureNameWrapper, null, elementName), React.createElement(FeatureIconWrapper, null, React.createElement("i", { className: elementIsFree ? "fa fa-check fa-lg" : "fa fa-times fa-lg" })), React.createElement(FeatureIconWrapper, null, React.createElement("i", { className: "fa fa-check fa-lg" })));
	};
	/** STYLES => PackageComparisonExpandableElementRow */
	var PackageComparisonExpandableElementRowWrapper = styled_components_1.default.div(_templateObject);
	var FeatureNameWrapper = styled_components_1.default.div(_templateObject2);
	var FeatureIconWrapper = styled_components_1.default.div(_templateObject3);
	var PackageComparisonExpandableElementLastRow = function PackageComparisonExpandableElementLastRow(props) {
	  return React.createElement(PackageComparisonExpandableElementLastRowWrapper, null, React.createElement(FeatureNameLastRowWrapper, null), React.createElement(FeatureIconLastRowWrapper, null), React.createElement(FeatureIconLastRowWrapper, null));
	};
	/** STYLES => PackageComparisonExpandableElementLastRow */
	var PackageComparisonExpandableElementLastRowWrapper = styled_components_1.default.div(_templateObject4);
	var FeatureNameLastRowWrapper = styled_components_1.default.div(_templateObject5);
	var FeatureIconLastRowWrapper = styled_components_1.default.div(_templateObject6);
	
	var PackageComparisonExpandableElement = function (_React$Component) {
	  _inherits(PackageComparisonExpandableElement, _React$Component);
	
	  function PackageComparisonExpandableElement(props) {
	    _classCallCheck(this, PackageComparisonExpandableElement);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      elementIsOpen: false
	    };
	    _this.toggleElement = _this.toggleElement.bind(_this);
	    return _this;
	  }
	
	  PackageComparisonExpandableElement.prototype.toggleElement = function toggleElement() {
	    var elementIsOpen = this.state.elementIsOpen;
	
	    this.setState({ elementIsOpen: !elementIsOpen });
	  };
	
	  PackageComparisonExpandableElement.prototype.render = function render() {
	    var _props = this.props,
	        appModuleName = _props.appModuleName,
	        appModuleElements = _props.appModuleElements;
	    var elementIsOpen = this.state.elementIsOpen;
	
	    return React.createElement(PackageComparisonExpandableElementWrapper, { className: "panel panel-default", onClick: this.toggleElement }, React.createElement("div", { className: "panel-heading" }, React.createElement("h3", { className: "panel-title" }, React.createElement("a", { className: elementIsOpen ? '' : 'collapsed', "aria-expanded": elementIsOpen }, appModuleName))), React.createElement("div", { className: elementIsOpen ? 'panel-collapse collapse in' : 'panel-collapse collapse' }, React.createElement("div", null, appModuleElements.map(function (element, index) {
	      return React.createElement(PackageComparisonExpandableElementRow, _extends({ key: index }, element));
	    })), React.createElement(PackageComparisonExpandableElementLastRow, null)));
	  };
	
	  return PackageComparisonExpandableElement;
	}(React.Component);
	/** STYLES */
	
	
	var PackageComparisonExpandableElementWrapper = styled_components_1.default.div(_templateObject7);
	exports.default = PackageComparisonExpandableElement;

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  flex-basis: 30%;\n  max-width: 300px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding-top: 30px;\n  padding-bottom: 10px;\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n  p {\n    margin: 0;\n    text-align: center;\n    color: #202020;\n    font-weight: bold;\n    font-size: 20px;\n    text-transform: uppercase;\n  }\n  a {\n    font-size: 12px !important;\n    font-weight: bold;\n  }\n  /* W\u0104SKI EKRAN => KOLUMNA 30% NIE MIE\u015ACI PRZYCISKU W JEDNEJ LINII (POZIOME PRZEWIJANIE STRONY) */\n  @media (max-width: 600px) {\n    min-width: 0;\n    padding-left: 3px;\n    padding-right: 3px;\n    p {\n      font-size: 12px;\n    }\n    a {\n      font-size: 10px !important;\n      white-space: normal !important;\n      height: auto !important;\n      line-height: 1.3 !important;\n      padding: 6px 2px !important;\n      letter-spacing: 0 !important;\n      max-width: 100%;\n    }\n  }\n"], ["\n  flex-basis: 30%;\n  max-width: 300px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding-top: 30px;\n  padding-bottom: 10px;\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n  p {\n    margin: 0;\n    text-align: center;\n    color: #202020;\n    font-weight: bold;\n    font-size: 20px;\n    text-transform: uppercase;\n  }\n  a {\n    font-size: 12px !important;\n    font-weight: bold;\n  }\n  /* W\u0104SKI EKRAN => KOLUMNA 30% NIE MIE\u015ACI PRZYCISKU W JEDNEJ LINII (POZIOME PRZEWIJANIE STRONY) */\n  @media (max-width: 600px) {\n    min-width: 0;\n    padding-left: 3px;\n    padding-right: 3px;\n    p {\n      font-size: 12px;\n    }\n    a {\n      font-size: 10px !important;\n      white-space: normal !important;\n      height: auto !important;\n      line-height: 1.3 !important;\n      padding: 6px 2px !important;\n      letter-spacing: 0 !important;\n      max-width: 100%;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  padding-right: 2px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  padding-right: 2px;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  flex-basis: 40%;\n"], ["\n  flex-basis: 40%;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var staticUrls = __webpack_require__(10);
	var styled_components_1 = __webpack_require__(2);
	var PackageComparisonHeaderElement = function PackageComparisonHeaderElement(props) {
	  var packageName = props.packageName,
	      buttonColor = props.buttonColor,
	      buttonLinkTo = props.buttonLinkTo;
	
	  return React.createElement(PackageComparisonHeaderElementWrapper, null, React.createElement("p", null, packageName), React.createElement("div", { className: "text-center mt-30" }, React.createElement("a", { href: buttonLinkTo, target: "_blank", className: "btn btn-md waves-effect waves-light " + buttonColor }, "Wypr\xF3buj ksi\u0119gowo\u015B\u0107")));
	};
	/** STYLES => PackageComparisonHeaderElement */
	var PackageComparisonHeaderElementWrapper = styled_components_1.default.div(_templateObject);
	var PackageComparisonHeader = function PackageComparisonHeader(props) {
	  return React.createElement(PackageComparisonWrapper, null, React.createElement(PackageComparisonHeaderElementPositioner, null), React.createElement(PackageComparisonHeaderElement, { packageName: "Pakiet bezpłatny", buttonColor: "", buttonLinkTo: staticUrls.FAKTUROMANIA_REGISTRATION_PAGE_URL }), React.createElement(PackageComparisonHeaderElement, { packageName: "Pakiet premium", buttonColor: "", buttonLinkTo: staticUrls.FAKTUROMANIA_REGISTRATION_PAGE_URL }));
	};
	/** STYLES => PackageComparisonHeader */
	var PackageComparisonWrapper = styled_components_1.default.div(_templateObject2);
	var PackageComparisonHeaderElementPositioner = styled_components_1.default.div(_templateObject3);
	exports.default = PackageComparisonHeader;

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  margin: 0;\n  padding: 18px 20px;\n  background: #f5f5f5;\n  color: #424242;\n  font-size: 16px;\n  font-weight: 500;\n  text-align: center;\n  span {\n    display: inline-block;\n    white-space: nowrap;\n  }\n  /* KROPKA ZA ELEMENTEM (NIE PRZED) => PRZY ZAWIJANIU NIE ZACZYNA NOWEJ LINII */\n  span:not(:last-child):after {\n    content: \"\xB7\";\n    margin: 0 10px;\n  }\n  /* W\u0104SKI EKRAN => DOWODY JEDEN POD DRUGIM, BEZ KROPEK */\n  @media (max-width: 414px) {\n    span {\n      display: block;\n    }\n    span + span {\n      margin-top: 6px;\n    }\n    span:not(:last-child):after {\n      content: none;\n    }\n  }\n  i {\n    margin-right: 7px;\n    color: #03a9f4;\n  }\n  a {\n    color: #1976d2;\n    text-decoration: underline;\n  }\n  a i {\n    text-decoration: none;\n  }\n"], ["\n  margin: 0;\n  padding: 18px 20px;\n  background: #f5f5f5;\n  color: #424242;\n  font-size: 16px;\n  font-weight: 500;\n  text-align: center;\n  span {\n    display: inline-block;\n    white-space: nowrap;\n  }\n  /* KROPKA ZA ELEMENTEM (NIE PRZED) => PRZY ZAWIJANIU NIE ZACZYNA NOWEJ LINII */\n  span:not(:last-child):after {\n    content: \"\xB7\";\n    margin: 0 10px;\n  }\n  /* W\u0104SKI EKRAN => DOWODY JEDEN POD DRUGIM, BEZ KROPEK */\n  @media (max-width: 414px) {\n    span {\n      display: block;\n    }\n    span + span {\n      margin-top: 6px;\n    }\n    span:not(:last-child):after {\n      content: none;\n    }\n  }\n  i {\n    margin-right: 7px;\n    color: #03a9f4;\n  }\n  a {\n    color: #1976d2;\n    text-decoration: underline;\n  }\n  a i {\n    text-decoration: none;\n  }\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var ProofBarBlock = function ProofBarBlock(props) {
	  var proofs = props.proofs;
	  // ZWRACANIE DANYCH
	
	  return React.createElement(ProofBarWrapper, null, proofs.map(function (proof, index) {
	    var content = [React.createElement("i", { key: "icon", className: proof.iconClassName, "aria-hidden": "true" }), proof.text];
	    return React.createElement("span", { key: index }, proof.link ? React.createElement("a", { href: proof.link, target: "_blank", rel: "noopener noreferrer" }, content) : content);
	  }));
	};
	/** STYLES */
	var ProofBarWrapper = styled_components_1.default.p(_templateObject);
	exports.default = ProofBarBlock;

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  position: fixed;\n  z-index: 997;\n  top: 40%;\n  right: 0;\n  /* TELEFON => ZNACZEK ZAS\u0141ANIA\u0141 TEKST SEKCJI, KSEF JEST WIDOCZNY W FUNKCJACH */\n  @media (max-width: 600px) {\n    display: none;\n  }\n"], ["\n  text-align: center;\n  position: fixed;\n  z-index: 997;\n  top: 40%;\n  right: 0;\n  /* TELEFON => ZNACZEK ZAS\u0141ANIA\u0141 TEKST SEKCJI, KSEF JEST WIDOCZNY W FUNKCJACH */\n  @media (max-width: 600px) {\n    display: none;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  color: #fff;\n  font-weight: 700;\n  text-transform: uppercase;\n"], ["\n  color: #fff;\n  font-weight: 700;\n  text-transform: uppercase;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  background-color: #3190E7;\n  box-shadow: 7px 6px 7px 0 rgba(0,0,0,.35);\n  transform: rotate(45deg);\n  position: absolute;\n  width: 195px;\n  border-radius: 15px;\n  right: -90px;\n  height: 200px;\n"], ["\n  background-color: #3190E7;\n  box-shadow: 7px 6px 7px 0 rgba(0,0,0,.35);\n  transform: rotate(45deg);\n  position: absolute;\n  width: 195px;\n  border-radius: 15px;\n  right: -90px;\n  height: 200px;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  font-size: 18px;\n  margin-top: -4px\n  cursor: default !important;\n  font-size: 15px;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 68px;\n  width: 105px;\n"], ["\n  font-size: 18px;\n  margin-top: -4px\n  cursor: default !important;\n  font-size: 15px;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 68px;\n  width: 105px;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var RightTriangleInfoBlock = function RightTriangleInfoBlock(props) {
	  return React.createElement(JPKInfoWrapper, null, React.createElement(JPKInfoButtonWrapper, null, React.createElement(BlueTriangleWrapper, null), React.createElement(JPKInfoTextWrapper, null, React.createElement("span", null, "JPK_CIT"), React.createElement("br", null), React.createElement("span", null, "KSeF"), React.createElement("br", null), React.createElement("span", null, "READY"))));
	};
	/** STYLES */
	var JPKInfoWrapper = styled_components_1.default.div(_templateObject);
	var JPKInfoButtonWrapper = styled_components_1.default.div(_templateObject2);
	var BlueTriangleWrapper = styled_components_1.default.div(_templateObject3);
	var JPKInfoTextWrapper = styled_components_1.default.div(_templateObject4);
	exports.default = RightTriangleInfoBlock;

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_helmet_1 = __webpack_require__(19);
	var hero_text_on_right_block_1 = __webpack_require__(143);
	var full_width_image_on_left_block_1 = __webpack_require__(341);
	var full_width_image_on_right_block_1 = __webpack_require__(142);
	var title_block_1 = __webpack_require__(38);
	var intro_step_block_1 = __webpack_require__(78);
	var features_box_simple_block_1 = __webpack_require__(77);
	var achievements_counter_block_1 = __webpack_require__(76);
	var promo_block_1 = __webpack_require__(80);
	var right_triangle_info_block_1 = __webpack_require__(81);
	var faq_block_1 = __webpack_require__(45);
	var package_comparison_block_1 = __webpack_require__(144);
	var proof_bar_block_1 = __webpack_require__(351);
	var types_1 = __webpack_require__(15);
	var google_analytics_1 = __webpack_require__(27);
	var helmetData = __webpack_require__(16);
	var staticUrls = __webpack_require__(10);
	var staticImages = __webpack_require__(33);
	var featuresData = __webpack_require__(75);
	var cacheBustingService = __webpack_require__(23);
	var faqQuestionsData = __webpack_require__(43);
	var companyData = __webpack_require__(37);
	
	var IndexPage = function (_React$Component) {
	    _inherits(IndexPage, _React$Component);
	
	    function IndexPage() {
	        _classCallCheck(this, IndexPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    IndexPage.prototype.componentDidMount = function componentDidMount() {
	        cacheBustingService.handleCacheBusting(caches);
	    };
	
	    IndexPage.prototype.render = function render() {
	        return React.createElement("div", null, React.createElement(react_helmet_1.Helmet, _extends({}, helmetData.prepareHelmetData(types_1.PageType.LandingPage))), React.createElement(hero_text_on_right_block_1.default, { titleLine1: "Pełna księgowość online", titleLine2: "dla spółek z o.o. i p.s.a.", description: ["Prowadź księgowość spółki w łatwy i przemyślany sposób, oszczędzaj czas i pieniądze.", "Program jest stworzony dla mikro spółek z o.o. i prostych spółek akcyjnych, dlatego jest uproszczony pod ich potrzeby.", "Od 95 zł netto/mies., bez abonamentu i bez zobowiązań. A gdy czegoś nie wiesz, podpowiemy."], buttonText: "Czym jest Fakturomania?", buttonLink: "https://pomoc.fakturomania.pl/support/solutions/articles/36000129929-czym-jest-fakturomania-", buttonLinkIsForScrolling: false, backgroundImage: staticImages.PIGGY_BANK_BACKGROUND_IMAGE, componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.LandingPageViewedMainTitleBlock, buttonClickEventType: google_analytics_1.GoogleAnalyticsEventType.LandingPageClickedCTAButtonAtMainTitleBlock }), React.createElement(proof_bar_block_1.default, { proofs: [{ iconClassName: "fa fa-calendar", text: companyData.FAKTUROMANIA_PROOF_SINCE }, { iconClassName: "fa fa-users", text: companyData.FAKTUROMANIA_PROOF_COMPANIES }, { iconClassName: "fa fa-google", text: companyData.FAKTUROMANIA_PROOF_GOOGLE_RATING, link: staticUrls.FAKTUROMANIA_GOOGLE_OPINIE_URL }] }), React.createElement(title_block_1.default, { id: "korzysci-spolki", firstLineBlackStart: "To", firstLineBlue: "prostsze,", firstLineBlackEnd: "niż myślisz", secondLineText: ["Z Fakturomanią wszystko masz pod ręką – wystawiasz faktury, prowadzisz księgowość i masz pełną kontrolę nad finansami swojej firmy w jednym, wygodnym systemie księgowym. Koniec z rozproszonymi narzędziami i skomplikowanymi procesami – teraz działasz szybciej, prościej i bezpieczniej.", "Nie komplikujemy – tłumaczymy, upraszczamy i automatyzujemy. Program jest stworzony dla małych spółek z o.o. i prostych spółek akcyjnych, więc jest uproszczony pod ich potrzeby. Tworzymy narzędzie, którego sami używamy.", "W aplikacji masz czat, w którym asystent AI odpowie od razu, o każdej porze, a jeśli wolisz albo sprawa jest trudniejsza, to porozmawiasz z księgowym serwisu.", "Spółka to nowe możliwości."] }), React.createElement(right_triangle_info_block_1.default, null), React.createElement(intro_step_block_1.default, { steps: [{
	                elementNumber: 1,
	                elementNumberColor: "lightgray",
	                elementTitle: "BRAK ZUS",
	                elementText: "Masz wybór. To do Ciebie należy decyzja czy sp. z o.o. albo p.s.a podlega pod ZUS - po prostu."
	            }, {
	                elementNumber: 2,
	                elementNumberColor: "blue",
	                elementTitle: "NISKIE PODATKI",
	                elementText: "Jeżeli roczne obroty spółki nie przekraczają kwoty 2 mln euro, to spółka stosuje stawkę 9% CIT."
	            }, {
	                elementNumber: 3,
	                elementNumberColor: "green",
	                elementTitle: "PROSTA KSIĘGOWOŚĆ",
	                elementText: "Która jest dostępna tylko dla mikroprzedsiębiorców - spółek prowadzonych w Polsce."
	            }], componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.LandingPageViewedIntroStepBlock }), React.createElement(full_width_image_on_left_block_1.default, { blockTitlePart1Black: "Istotne ", blockTitlePart2Blue: "Oszczędności", blockTitlePart3Black: "", blockSubtitle: ["Ile wi\u0119c mo\u017Cna zyska\u0107 w " + companyData.FAKTUROMANIA_CURRENT_YEAR], numberBoxParagraphs: ["Spółka z o.o. lub p.s.a. pozwoli Ci ograniczyć koszty ZUS, to ponad 1900 zł miesięcznie. W roku to kwota co najmniej kilkunastu tysięcy złotych.", "Stawka podatku 9% CIT to oszczędność względem pozostałych form zarobkowania w Polsce, zwłaszcza względem JDG.", "Księgowość online z Fakturomanią pozwala znacząco ograniczyć koszty rozliczenia. To kolejne kilkaset złotych miesięcznie, które pozostaje w Twojej firmie.", "Ale to nie wszystko, zalet jest znacznie więcej."], odometers: [{
	                odometerTitle: "OSZCZĘDNOŚĆ ZUS",
	                odometerStart: 0,
	                odometerEnd: 1982,
	                odometerSuffix: " zł / mc",
	                odometerDuration: 7
	            }, {
	                odometerTitle: "STAWKA CIT",
	                odometerStart: 19,
	                odometerEnd: 9,
	                odometerSuffix: "%",
	                odometerDuration: 5
	            }, {
	                odometerTitle: "NIŻSZE KOSZTY KSIĘGOWOŚCI",
	                odometerStart: 0,
	                odometerEnd: 700,
	                odometerSuffix: " zł / mc",
	                odometerDuration: 7
	            }, {
	                odometerTitle: "ŚREDNIA OSZCZĘDNOŚĆ",
	                odometerStart: 0,
	                odometerEnd: 2682,
	                odometerSuffix: " zł / mc",
	                odometerDuration: 5
	            }], componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.LandingPageViewedOdometersBlock }), React.createElement(title_block_1.default, { firstLineBlackStart: "Program do", firstLineBlue: "pełnej księgowości", firstLineBlackEnd: "spółki z o.o.", secondLineText: ["Fakturomania to program do pełnej księgowości online spółki z o.o. i p.s.a. Prowadzisz w nim księgowość, wystawiasz faktury z integracją z KSeF, wysyłasz deklaracje podatkowe z plikami JPK i przygotowujesz sprawozdanie finansowe.", "Nasza aplikacja jest intuicyjna i prosta w obsłudze, zawiera bogatą bazę wiedzy, ale co najważniejsze, wsparcie techniczne i księgowe.", "Odbieramy, odpisujemy, tłumaczymy — codziennie pomagamy użytkownikom w pierwszych krokach i bardziej zawiłych sytuacjach.", "Jesteśmy po to, żeby księgowość przestała być problemem."], paddingTop: 0, paddingBottom: 0 }), React.createElement(features_box_simple_block_1.default, { features: featuresData.STANDARD_APP_FEATURES, componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.LandingPageViewedFeaturesBlock, buttonClickEventType: google_analytics_1.GoogleAnalyticsEventType.LandingPageNavigatedToPackagesComparisonPage }), React.createElement(full_width_image_on_right_block_1.default, { blockTitlePart1Black: "Płacisz, kiedy potrzebujesz. ", blockTitlePart2Blue: "Wszystko pod kontrolą", blockTitlePart3Black: "", blockSubtitle: ["Bez automatycznego odnawiania — kupujesz pakiet (miesiąc, kwartał, pół roku albo rok), kiedy go potrzebujesz.", "Sam decydujesz o płatnościach i na bieżąco widzisz, co dzieje się w księgowości spółki."], blockParagraphs: ["Fakturomania została zaprojektowana w taki sposób, aby każdy mógł samodzielnie prowadzić księgowość spółki, a księgowi nie musieli dokonywać żmudnych i kosztowych konfiguracji.", "Fakturomania to bardzo intuicyjny interfejs, rozbudowana baza wiedzy oraz zespół, który odpowie na Twoje pytania. Fakturomania daje realną pomoc, dla której otrzymania nie trzeba wykupywać jakichś specjalnych odrębnie płatnych pakietów.", "Robi się coś dobrze, albo nie robi się wcale. Nasz zespół specjalizuje się w spółkach, dlatego jesteśmy tak dobrzy w tym co robimy.", "Przekonaj się, jak prosta może być z nami pełna księgowość twojej spółki."], blockButtonText: "WYPRÓBUJ APLIKACJĘ", blockButtonLink: staticUrls.FAKTUROMANIA_REGISTRATION_PAGE_URL, componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.LandingPageViewedDescriptionBlock, buttonClickEventType: google_analytics_1.GoogleAnalyticsEventType.LandingPageClickedCTAButtonAtDescriptionBlock }), React.createElement(title_block_1.default, { firstLineBlackStart: "Prowadź", firstLineBlue: "spółkę", firstLineBlackEnd: "z Fakturomanią", secondLineText: "Zarządzaj swoją spółką bez stresu i straty czasu. Fakturomania to wsparcie księgowe dla spółek – całkowicie online, przejrzyście i bez zbędnych formalności.", paddingTop: 100 }), React.createElement(faq_block_1.default, { faqQuestions: faqQuestionsData.MAIN_PAGE_FAQ_QUESTIONS, componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.ZakladanieSpolekZooViewedFaqBlock, faqQuestionReadEventType: google_analytics_1.GoogleAnalyticsEventType.ZakladanieSpolekZooReadFaqQuestion }), React.createElement(title_block_1.default, { firstLineBlackStart: "Co masz w", firstLineBlue: "programie księgowym", firstLineBlackEnd: "dla spółki", secondLineText: "Nasz system księgowy to coś więcej niż tylko wystawianie faktur. To kompleksowe narzędzie, które automatyzuje, upraszcza i wspiera każdy etap pracy z księgowością – od ewidencji dokumentów, przez raportowanie, po rozliczenia podatkowe. Fakturomania to również baza wiedzy, w której można odnaleźć nawet takie materiały, które omawiają jak prowadzić księgowość, tak krok po kroku, od organizacji segregatora księgowego zaczynając, a na przygotowaniu, zatwierdzeniu oraz złożeniu sprawozdania finansowego kończąc.", paddingTop: 100 }), React.createElement(package_comparison_block_1.default, null), React.createElement(title_block_1.default, { firstLineBlackStart: "Księgowość w ", firstLineBlue: "Fakturomanii", firstLineBlackEnd: "w liczbach", secondLineText: "Działamy już na rynku długi czas, mamy bogate doświadczenie, zaś system to owoc mądrej i przemyślanej pracy." }), React.createElement(achievements_counter_block_1.default, { counters: [{
	                iconString: "watch",
	                counterStart: 0,
	                counterEnd: companyData.FAKTUROMANIA_YEARS_ON_MARET,
	                counterDuration: 3,
	                counterText: "LAT NA RYNKU"
	            }, {
	                iconString: "person",
	                counterStart: 0,
	                counterEnd: 9,
	                counterDuration: 5,
	                counterText: "TYS. FIRM"
	            }, {
	                iconString: "description",
	                counterStart: 0,
	                counterEnd: 11,
	                counterDuration: 5,
	                counterText: "MLN KSIĘGOWAŃ W SERWISIE"
	            }], componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.LandingPageViewedAchievementsBlock }), React.createElement(promo_block_1.default, { promoBlockType: types_1.PromoBlockType.PromoBlockGrayBox, promoBlockTitle: "PO PROSTU SPRAWDŹ I WYPRÓBUJ FAKTUROMANIĘ DZIŚ", promoBlockText: "Przekonaj się, jak prosta może być księgowość spółki.", promoBlockButtonText: "WYPRÓBUJ BEZPŁATNIE", promoBlockLink: staticUrls.FAKTUROMANIA_REGISTRATION_PAGE_URL }));
	    };
	
	    return IndexPage;
	}(React.Component);
	
	exports.pageQuery = "** extracted graphql fragment **";
	exports.default = IndexPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-tsx-d94661af8140ffea624c.js